import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "dateInput" ]
  static values  = {
    url: String,
    packageId: String,
    dronePointId: String,
    packageOptionId: String
  }

  connect() {
    document.getElementById("schedule-options")
            .addEventListener("turbo:frame-load", this.onFrameLoad.bind(this))

    if (this.dateInputTarget.value) {
      this.fetchOptions()
    }
  }

  fetchOptions() {
    const date = this.dateInputTarget.value
    if (!date) return

    const packageId = this.packageIdValue
    const dronePointId = this.dronePointIdValue

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("date", date)
    url.searchParams.set("package_id", packageId)
    url.searchParams.set("drone_point_id", dronePointId)

    const frame = document.getElementById("schedule-options")
    frame.setAttribute("src", url.toString())
  }

  onFrameLoad() {
    const hasSlots = document.querySelector(
      "input[name='booking[activities_attributes][0][activity_schedule_attributes][start_at]']"
    )
    hasSlots ? this.enableSubmit() : this.disableSubmit()
  }

  disableSubmit() {
    const btn = document.getElementById("checkoutSubmitButton")
    if (btn) btn.disabled = true
  }

  enableSubmit() {
    const btn = document.getElementById("checkoutSubmitButton")
    if (btn) btn.disabled = false
  }

  selectPackageOption(event) {
    const card = event.currentTarget
    const packageOptionId = card.getAttribute("data-package-option-id")
    const dronePointId = card.getAttribute("data-drone-point-id")
    if (!packageOptionId || !dronePointId) return

    // Update the Stimulus values
    this.packageOptionIdValue = packageOptionId
    this.dronePointIdValue = dronePointId

    // Update hidden inputs for package_option_id
    const packageOptionInputs = this.element.querySelectorAll("input[name*='[package_option_id]']")
    packageOptionInputs.forEach(input => {
      input.value = packageOptionId
    })

    // Update hidden inputs for drone_point_id
    const dronePointInputs = this.element.querySelectorAll("input[name*='[drone_point_id]']")
    dronePointInputs.forEach(input => {
      input.value = dronePointId
    })

    // Update selected card styling (border, background, radio dots, icons, and text)
    const cards = this.element.querySelectorAll(".package-option-card")
    cards.forEach(c => {
      const isSelected = (c === card)
      
      // 1. Card container
      if (isSelected) {
        c.classList.remove("border-border", "bg-background")
        c.classList.add("border-navy", "bg-navy/[0.02]", "shadow-sm")
      } else {
        c.classList.remove("border-navy", "bg-navy/[0.02]", "shadow-sm")
        c.classList.add("border-border", "bg-background")
      }

      // 2. Icon wrapper
      const iconWrapper = c.querySelector(".h-10.w-10")
      if (iconWrapper) {
        if (isSelected) {
          iconWrapper.classList.remove("bg-surface", "text-muted-foreground")
          iconWrapper.classList.add("bg-navy/10", "text-navy")
        } else {
          iconWrapper.classList.remove("bg-navy/10", "text-navy")
          iconWrapper.classList.add("bg-surface", "text-muted-foreground")
        }
      }

      // 3. Label tag text
      const labelText = c.querySelector("span.uppercase")
      if (labelText) {
        if (isSelected) {
          labelText.classList.remove("text-muted-foreground/70")
          labelText.classList.add("text-navy/70")
        } else {
          labelText.classList.remove("text-navy/70")
          labelText.classList.add("text-muted-foreground/70")
        }
      }

      // 4. Name text
      const nameText = c.querySelector("span.text-sm")
      if (nameText) {
        if (isSelected) {
          nameText.classList.remove("text-navy/80")
          nameText.classList.add("text-navy")
        } else {
          nameText.classList.remove("text-navy")
          nameText.classList.add("text-navy/80")
        }
      }

      // 5. Radio circle indicator
      const radioCircle = c.querySelector(".h-5.w-5.rounded-full")
      if (radioCircle) {
        if (isSelected) {
          radioCircle.classList.remove("border-border", "bg-background")
          radioCircle.classList.add("border-navy", "bg-navy")
        } else {
          radioCircle.classList.remove("border-navy", "bg-navy")
          radioCircle.classList.add("border-border", "bg-background")
        }
      }

      // 6. Radio inner dot
      const radioDot = c.querySelector(".h-2.w-2")
      if (radioDot) {
        if (isSelected) {
          radioDot.classList.remove("scale-0")
          radioDot.classList.add("scale-100")
        } else {
          radioDot.classList.remove("scale-100")
          radioDot.classList.add("scale-0")
        }
      }
    })

    // Refetch slots
    this.fetchOptions()
  }
}
